export const APP_NAME = "Everpesa Invest";
export const TAGLINE = (
  <>
    Invest. <b>Bank.</b> Grow.
  </>
);

// CONSTANTS
export const LOGIN = "login";
export const REGISTER = "register";
export const INDIVIDUAL = "individual";
export const SUBMIT = "submit";
export const SAVE = "save";
export const ERROR_DEFAULT_MESSAGE = "An unknown error occured";
export const SUCCESS_DEFAULT_MESSAGE = "Successfully submitted";
export const ACCOUNT = "account";
export const WALLET = "wallet";
export const INVESTMENTS = "investments";
export const INVESTMENT_PLANS = "investment_plans";
export const LOANS = "loans";
export const INVEST = "invest";
export const AUTOINVEST = "autoinvest";
export const TRANSACTIONS = "transactions";
export const NOTIFICATIONS = "notifications";
export const HOME = "home";
export const DEPOSIT = "deposit";
export const TOP_UP = "top_up";
export const WITHDRAW = "withdraw";
export const TRANSFER = "transfer";
export const ONBOARD = "onboard";
export const VIEW_ALL = "View All";
export const FUND_LOAN = "fund_loan";
export const PASSWORD_RESET = "password_reset";
export const OTP_LOGIN = "otp_login";
export const OTP_RESET = "otp_reset";
export const OTP_VERIFY_SIGNUP = "otp_verify_signup";
export const INSTALLMENTS = "installments";
export const REPAYMENTS = "repayments";
export const REPAY = "repay";
export const FUNDED = "funded";
export const INSTITUTIONS = "institutions";
export const PRODUCTS = "products";

// Device financing
export const DEVICES = "devices";
export const DEVICE_ORDERS = "device_orders";
export const ORDER_DEVICE = "order_device";
export const PAY_DEPOSIT = "pay_deposit";
export const CONFIRM_DELIVERY = "confirm_delivery";
export const EARLY_SETTLE = "early_settle";
export const ACCEPT_OFFER = "accept_offer";

// FORM FIELD TYPES
export const TEXT = "text";
export const SELECT = "select";
export const SELECT_VIEW = "select_view";
export const DATE = "date";
export const CHECK_BOX = "check_box";
export const SWITCH = "switch";
export const COMPONENT = "component";
export const FILE = "file";

// CONFIG
export const FORMDATA = "formdata";
export const MULTIPLE = "multiple";
export const APP_BAR_HEIGHT = "56px";
export const LEFT_MENU_WIDTH = "180px";
export const USER = "user";

export const DATE_TIME_FORMAT = "DD MMM YYYY, HH:mm";
export const DATE_FORMAT = "DD MMM YYYY";

// USER TYPES
export const INVESTOR = "investor";
export const BORROWER = "borrower";

// STATUS
export const PENDING = "pending";
export const CLOSED = "closed";
export const ACTIVE = "active";
export const PAID = "paid";
export const COMPLETED = "completed";
export const REPAID = "repaid";
export const DEFAULTED = "defaulted";
export const FAILED = "failed";
export const SUCCESS = "success";
export const LATE = "late";

// TRANSFER ACTIONS
export const WALLET_TO_MOBILE = "wallet_to_mobile";
export const MOBILE_TO_WALLET = "mobile_to_wallet";

// payment_method
export const MOBILE_MONEY = "mobile_money";
export const BANK_ACCOUNT = "bank_account";
export const CASH_AT_AGENT = "cash_at_agent";


// Manual Operations
export const MANUAL_DEPOSITS = "manual_deposits";
export const MANUAL_WITHDRAWALS = "manual_withdrawals";
export const MANUAL_REPAYMENTS = "manual_repayments";
export const NEW_MANUAL_DEPOSIT = "new_manual_deposit";
export const NEW_MANUAL_WITHDRAWAL = "new_manual_withdrawal";
export const SUBMIT_MANUAL_REPAYMENT = "submit_manual_repayment";
 
// User Accounts
export const BANK_ACCOUNTS = "bank_accounts";
export const MOMO_ACCOUNTS = "momo_accounts";
export const ADD_BANK_ACCOUNT = "add_bank_account";
export const ADD_MOMO_ACCOUNT = "add_momo_account";
 
// Status additions
export const CREDITED = "credited";
export const PROCESSED = "processed";
export const REJECTED = "rejected";
 